import {
  activitygroupFilterLabel,
  articletypeFilterLabel,
  keyarticlesFilterLabel,
  linenameFilterLabel,
  maindistributionchannelFilterLabel,
  retailPriceFilterLabel,
  sizeFilterLabel,
  wholesalePriceFilterLabel,
} from './filter-labels';

// each key corresponds to a facetId
export const filterPillLabels: { [key: string]: string } = {
  isdDates: $localize`:productBasket|Translation for global isd filterPill@@globalISDPillFilterName:ISD`,
  wholesalePriceRange: wholesalePriceFilterLabel,
  retailPriceRange: retailPriceFilterLabel,
  dc: maindistributionchannelFilterLabel,
  size: sizeFilterLabel,
  isglobalnoos: $localize`:productBasket|Translation for NOOS filterPill@@noosPillFilterName:NOOS`,
  articletype: articletypeFilterLabel,
  linename: linenameFilterLabel,
  activitygroup: activitygroupFilterLabel,
  strategictype: $localize`:productBasket|Translation for license filterPill@@licenseGroupPillFilterName:License`,
  isclosedoutproduct: $localize`:productBasket|Translation for closed out filterPill@@closeOutPillFilterName:Close-out product`,
  keyarticles: keyarticlesFilterLabel,
  filterOutInbound: $localize`:productBasket|Translation for inbound filterFill@@inboundFilterPillName:Inbound`,
  filterOutRecentlyDelivered: $localize`:productBasket|Translation for recently delivered filterFill@@recentlyDeliveredFilterPillName:Recently Delivered`,
};
